import OtsTable from "./OtsTable"

OtsTable.install = Vue => {
    vue.component(OtsTable.name,OtsTable)
}


export default OtsTable